/*
 * Copyright © 2020-2025. Verizon Connect Ireland Limited. All rights reserved.
 */

import { AbstractControl, FormControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function MatchValidator(controlToMatch: FormControl<string>): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (control && controlToMatch) {
      if (controlToMatch.valid) {
        if (controlToMatch.value !== control.value) {
          return { mismatch: true };
        }
      } else {
        return { invalidMatch: true };
      }
    }

    return null;
  };
}
